import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'

import Card, { CardContent, CardActions } from 'material-ui/Card'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'

import styles from 'styles/components/NoKeys'

@withStyles(styles)
@observer
export default class NoKeys extends Component {

  static propTypes = {
    message: PropTypes.string
  }

  static defaultProps = {
    message: 'У Вас пока нет ни одного ключа'
  }

  render() {
    const { classes, message } = this.props

    return (
      <Card elevation={1} className={ classes.card } >
        <CardContent>
          <Typography color='primary' type='subheading' >
            { message }
          </Typography>
        </CardContent>
        <CardActions>
          <Button fullWidth href='/#/dashboard' >
            Купить ключ
          </Button>
        </CardActions>
      </Card>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/NoKeys.js